import aa from 'search-insights';
import { checkConsent } from '../../../../../utils/checkConsent';
import { getUserToken } from '../get_user_token/getUserToken';
import type { ClickAfterSearchEventParams } from './clickAfterSearchEventType';

export const sendClickAfterSearchEvent = async ({
  eventName,
  index,
  queryID,
  objectID,
  position,
}: ClickAfterSearchEventParams) => {
  const hasConsent = checkConsent();
  if (!hasConsent) return;
  const userToken = await getUserToken();
  aa('clickedObjectIDsAfterSearch', {
    userToken: userToken as string,
    eventName,
    index,
    queryID,
    objectIDs: [objectID],
    positions: [position],
  });
};
